import { useAuth } from '@/shared/hooks/useAuth';

// The backend's `authorize('admin', 'owner')` on the integration routes lets in admin, owner and
// agency_admin (an agency user's role, which outranks every practice role).
const SYNC_ROLES = new Set(['admin', 'owner', 'agency_admin']);

/** Whether the user may sync, disconnect or edit an integration. A manager or viewer would only
 *  get a 403, so the UI hides those controls. */
export function useCanSyncIntegrations(): boolean {
  const { user } = useAuth();
  return SYNC_ROLES.has(user?.role ?? '');
}
